import { Text } from '@nominex/dex-uikit'
import styled from 'styled-components'
import { AutoColumn } from 'components/Layout'

export const Wrapper = styled.div`
  position: relative;
  padding-top: 20px;
`

export const ErrorText = styled(Text)<{ severity?: 0 | 1 | 2 | 3 | 4 }>`
  color: ${({ theme, severity }) =>
    severity === 3 || severity === 4
      ? theme.colors.failure
      : severity === 2
        ? theme.colors.warning
        : severity === 1
          ? theme.colors.text
          : theme.colors.primary};
`
export const StyledBalanceMaxMini = styled.button`
  height: 24px;
  width: 24px;
  background-color: ${({ theme }) => theme.colors.primary}33;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;

  :hover {
    background-color: ${({ theme }) => theme.colors.primary}44;
  }

  :focus {
    background-color: ${({ theme }) => theme.colors.primary}44;
    outline: none;
  }
`

export const TruncatedText = styled(Text).attrs({ ellipsis: true })`
  width: 220px;
`

export const SwapShowAcceptChanges = styled(AutoColumn)`
  background-color: ${({ theme }) => `${theme.colors.warning}33`};
  padding: 0.5rem;
  border-radius: 12px;
  margin-top: 8px;
`
